import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.013 22.536c.004-2.172.004-3.77-.002-4.72A3 3 0 0 0 44 14.993V11.3a5 5 0 0 0-4.805-4.996 386.623 386.623 0 0 0-15.015-.268c-5.482 0-10.606.091-15.371.274A5 5 0 0 0 4 11.306V15a3.003 3.003 0 0 0 1.99 2.817c-.007.95-.007 2.548-.003 4.72l.005 2.272.006 1.991L6 28.018c0 2.635.062 4.945.188 6.93a7 7 0 0 0 6.409 6.536c4.448.368 8.265.552 11.454.552 3.178 0 6.963-.183 11.355-.549a7 7 0 0 0 6.406-6.534c.125-1.987.188-4.298.188-6.935l.002-1.214.006-1.991.005-2.277ZM18 21v-3h12v3a1 1 0 0 1-1 1H19a1 1 0 0 1-1-1Z",
    fill: "currentColor"
  }));
};

var SvgArchive = styled(SvgComponent).withConfig({
  displayName: "Archive__SvgArchive",
  componentId: "sc-11youx-0"
})(["", " ", ""], size, color);
export default SvgArchive;